export default __webpack_public_path__ + "static/media/WAS0380.34I-39715_-23568_0.fd7cd077.jpg";